import { useNavigate } from "react-router-dom";
import { ClipboardCheck, FileEdit, MessageSquareText, CalendarPlus, Megaphone, Star } from "lucide-react";

/**
 * The 2-click execution zone. Any staff/admin can trigger the four most
 * common daily verbs from Home. Cast are handled by HomeTodayStrip (their
 * dashboard is passive — read next call, read tagged notes, done).
 */
export default function HomeQuickActions({ role, todayRehearsalId }) {
  const nav = useNavigate();
  if (role === "cast") return null;

  const actions = [
    { id: "attendance", label: "Take attendance", icon: ClipboardCheck,
      hint: todayRehearsalId ? "For today's rehearsal" : "Pick a rehearsal",
      onClick: () => nav("/rehearsals?tab=attendance") },
    { id: "file-report", label: "File report", icon: FileEdit,
      hint: "Wrap-up + actionables",
      onClick: () => nav("/rehearsals?tab=reports&new=1") },
    { id: "post-cast-note", label: "Post cast note", icon: MessageSquareText,
      hint: "Send notes to actors",
      onClick: () => nav("/notes-hub?tab=cast&new=1") },
    { id: "add-rehearsal", label: "Add rehearsal", icon: CalendarPlus,
      hint: "Schedule a call",
      onClick: () => nav("/calendar?new=1") },
    { id: "announce", label: "Announce", icon: Megaphone,
      hint: "Broadcast the company",
      onClick: () => nav("/announcements?new=1") },
    { id: "audition-slot", label: "Audition slot", icon: Star,
      hint: "Open more slots",
      onClick: () => nav("/auditions?slots=1") },
  ];

  return (
    <div className="rounded-2xl border border-white/10 bg-[#0F0F0F] p-4 md:p-5" data-testid="home-quick-actions">
      <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 mb-3">Quick actions</div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
        {actions.map(({ id, label, icon: Icon, hint, onClick }) => (
          <button
            key={id}
            data-testid={`quick-action-${id}`}
            onClick={onClick}
            className="group text-left rounded-lg border border-white/10 bg-[#121212] p-3 hover:border-gold/40 hover:bg-gold/5 transition-colors"
          >
            <div className="w-8 h-8 rounded grid place-items-center bg-gold/10 text-gold group-hover:bg-gold group-hover:text-black transition-colors">
              <Icon className="w-4 h-4" />
            </div>
            <div className="mt-2 text-sm text-zinc-100 leading-tight">{label}</div>
            <div className="text-[10px] text-zinc-500 mt-0.5">{hint}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
